// extracted by mini-css-extract-plugin
export default {"omni-characteristics-banner-link":"OmniCharacteristicsBanner_omni-characteristics-banner-link__bQH5Z"};